module.exports = __webpack_public_path__ + "img/QuilityLogoHorizontal.3257fcc1.svg";